import React, { useCallback, useEffect, useState, useRef, memo } from 'react';
const testimonials = [{
  name: 'Lucía M.',
  location: 'Córdoba',
  role: 'Estudiante de Psicología — 2do año',
  avatarBg: '#B8860B',
  quote: 'Tenía tres parciales en el mismo mes y no sabía por dónde arrancar. Con el Tomo 3 encontré todo el psicoanálisis ordenado: primera tópica, segunda tópica, Edipo. En dos días tenía todo claro. Aprobé con un 8.',
  time: '22:14',
  reply: 'Eso es exactamente para lo que está pensado 🙌 Cuando el contenido está ordenado y con ejemplos, el parcial deja de ser un drama.'
}, {
  name: 'Florencia S.',
  location: 'Buenos Aires',
  role: 'Estudiante de Psicología — 3er año',
  avatarBg: '#7A9E7E',
  quote: 'Lo que más me cambió fue tener un sistema claro. Antes perdía horas buscando apuntes que no coincidían. Con el MegaPack supe exactamente qué estudiar, en qué orden y cómo conectar los temas entre sí.',
  time: '11:30',
  reply: 'Me alegra un montón 😄 Ese es el objetivo: que dejes de buscar y empieces a estudiar de verdad.'
}, {
  name: 'Valentina P.',
  location: 'Rosario',
  role: 'Estudiante de Psicología — 2do año',
  avatarBg: '#C8922A',
  quote: 'Arranqué la carrera sintiéndome perdida con tanta bibliografía. El Tomo 1 me dio el orden que la facultad nunca me dio. Ya aprobé 6 materias con él y por primera vez siento que realmente entiendo lo que estudio.',
  time: '16:52',
  reply: 'Qué bueno 🥹 El Tomo 1 está hecho exactamente para eso: que no te pierdas en el primer año.'
}, {
  name: 'Camila B.',
  location: 'Tucumán',
  role: 'Estudiante de Psicología — 3er año',
  avatarBg: '#6B4C35',
  quote: 'Estaba en el peor momento de la carrera. Tres finales juntos, trabajo part-time y sin plata para clases particulares. El Tomo 5 de Clínica me salvó el cuatrimestre. Todo lo que necesitaba en un solo lugar.',
  time: '09:03',
  reply: 'Esa situación es muy real y muy difícil 😔 Me alegra que hayas encontrado lo que necesitabas. Ya falta poco.'
}, {
  name: 'Sofía G.',
  location: 'Mendoza',
  role: 'Estudiante de Psicología — 2do año',
  avatarBg: '#9A7B5A',
  quote: 'Los cuadros comparativos del Tomo 2 son lo que debería darte la facultad el primer día. Neuronas, sinapsis, lóbulos cerebrales en una sola hoja. Dejé de buscar en 5 libros distintos.',
  time: '19:27',
  reply: 'Exacto, para eso está 😊 Que todo esté en un lugar te ahorra tiempo y energía para lo que importa: entender y aprobar.'
}, {
  name: 'Mateo H.',
  location: 'Santa Fe',
  role: 'Estudiante de Psicología — 3er año',
  avatarBg: '#7A9E7E',
  quote: 'Le tenía miedo al final de Psicopatología. Es la materia que más recursa en mi facultad. Usé el Tomo 5 completo con los criterios diagnósticos y los casos. Aprobé de primera con un 9. No lo puedo creer todavía.',
  time: '14:11',
  reply: 'Creelo, te lo ganaste 💪 Psicopatología asusta porque es mucho contenido disperso. El Tomo 5 está hecho para ordenar exactamente eso.'
}, {
  name: 'Agustina P.',
  location: 'Salta',
  role: 'Estudiante de Psicología — 1er año',
  avatarBg: '#B8860B',
  quote: 'Soy más de estudiar con ejemplos que con teoría pura. El Tomo 1 tiene los sistemas psicológicos explicados con contexto real desde el primer capítulo. Primera vez que entiendo para qué sirve lo que estudio.',
  time: '21:05',
  reply: 'Eso marca toda la diferencia 😌 Cuando sabés por qué estudiás algo, lo recordás mucho mejor. Esa es la idea detrás de cada tomo.'
}];
function getInitials(name: string) {
  const parts = name.replace(/\./g, '').trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
function ChevronLeft() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-331">
      <path d="M15 18l-6-6 6-6" data-id="element-332" />
    </svg>;
}
function ChevronRight() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-333">
      <path d="M9 18l6-6-6-6" data-id="element-334" />
    </svg>;
}
const WhatsAppChat = memo(function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-335">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-336">
        <div className="relative" data-id="element-337">
          <div aria-hidden="true" className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{
          backgroundColor: t.avatarBg
        }} data-id="element-338">
            {getInitials(t.name)}
          </div>
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-339" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-340">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-341">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-342">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-343">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-344">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-345" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 min-h-[160px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a'
    }} data-id="element-346">
        {/* Incoming bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-347">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-348" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-349">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-350">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-351">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-352">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-353">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-354" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-355" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble — dorado en lugar de azul */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-356">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #B8860B',
          borderRight: '8px solid transparent'
        }} data-id="element-357" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)'
        }} data-id="element-358">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#fff'
          }} data-id="element-359">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-360">
              <span className="text-xs" style={{
              color: 'rgba(255,255,255,0.7)'
            }} data-id="element-361">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-362">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="rgba(255,255,255,0.85)" data-id="element-363" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="rgba(255,255,255,0.85)" data-id="element-364" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-365">
        <div style={{
        color: '#8696a0'
      }} data-id="element-366">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-367">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-368" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-369">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-370">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-371">
            <path d="M12 15c1.66 0 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-372" />
          </svg>
        </div>
      </div>
    </div>;
});
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setSlideDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 250);
  }, [isAnimating]);
  const next = useCallback(() => {
    goTo((current + 1) % total, 'left');
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'right');
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section className="relative w-full px-4 sm:px-6 lg:px-8 py-10" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, #FDF4E7 30%, #FEFAF4 100%)'
  }} data-id="element-373">
      <div className="mx-auto max-w-2xl" data-id="element-374">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center m-0 mb-2" style={{
        color: '#1E1208'
      }} data-id="element-375">
          Lo que dicen los estudiantes{' '}
          <span style={{
          color: '#C8922A'
        }} data-id="element-376">
            que ya lo usan:
          </span>
        </h2>
        <p className="text-center text-sm m-0 mb-8" style={{
        color: '#9A7B5A'
      }} data-id="element-377">
          +1.800 estudiantes de todo el país ya tienen la carrera organizada.
        </p>

        {/* Carousel */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-378">
          {/* Arrow prev */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-0 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-379">
            <ChevronLeft data-id="element-380" />
          </button>

          {/* Arrow next */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-0 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-381">
            <ChevronRight data-id="element-382" />
          </button>

          {/* Card */}
          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-383">
            <div style={{
            transition: isAnimating ? 'none' : 'opacity 0.25s ease, transform 0.25s ease',
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating ? `translateX(${slideDirection === 'left' ? '-30px' : '30px'})` : 'translateX(0)'
          }} data-id="element-384">
              <WhatsAppChat t={testimonials[current]} data-id="element-385" />
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgba(200,146,42,0.15)'
        }} data-id="element-386">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            background: 'linear-gradient(to right, #B8860B, #C8922A)',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-387" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-388">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'left' : 'right')} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#C8922A' : 'rgba(200,146,42,0.25)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-389" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs" style={{
          color: '#9A7B5A'
        }} data-id="element-390">
            {current + 1} / {total}
          </p>
        </div>
      </div>

      {/* Degradé inferior → conecta con FAQ */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FEFAF4 100%)'
    }} data-id="element-391" />
    </section>;
}